import React from "react";
import { redirectToLoginPage } from "../../utils/auth-provider";
import "./SignedOut.css";

interface SignedOutProps {
  onSignIn?: () => void;
}

const SignedOut: React.FC<SignedOutProps> = ({ onSignIn }) => {
  const handleSignIn = () => {
    sessionStorage.removeItem('msa_signed_out');
    if (onSignIn) {
      onSignIn();
    }
    redirectToLoginPage();
  };

  return (
    <div className="signed-out-page">
      <div className="signed-out-page__content">
        <p className="signed-out-page__message">You have been signed out.</p>
        <button className="signed-out-page__button" onClick={handleSignIn}>
          Sign in again
        </button>
      </div>
    </div>
  );
};

export default SignedOut;
